"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var LapModeling_exports = {};
__export(LapModeling_exports, {
  default: () => LapModeling_default
});
module.exports = __toCommonJS(LapModeling_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.418 13.9414V12.3984C11.418 12.2943 11.4505 12.2096 11.5156 12.1445C11.5938 12.0664 11.6849 12.0273 11.7891 12.0273H13.7422V10.0156L11.2227 7.51562H9.58203V9.21484C9.58203 9.30599 9.54297 9.39062 9.46484 9.46875C9.39974 9.53385 9.3151 9.56641 9.21094 9.56641H7.25781V12.0273H9.21094C9.3151 12.0273 9.39974 12.0664 9.46484 12.1445C9.54297 12.2096 9.58203 12.2943 9.58203 12.3984V13.9414H11.418ZM16.9844 7.51562L14.4648 10.0156V12.0273H16.418C16.5221 12.0273 16.6068 12.0664 16.6719 12.1445C16.75 12.2096 16.7891 12.2943 16.7891 12.3984V16.3633C16.7891 16.4674 16.75 16.5586 16.6719 16.6367C16.6068 16.7018 16.5221 16.7344 16.418 16.7344H11.7891C11.6849 16.7344 11.5938 16.7018 11.5156 16.6367C11.4505 16.5586 11.418 16.4674 11.418 16.3633V14.6641H9.58203V16.3633C9.58203 16.4674 9.54297 16.5586 9.46484 16.6367C9.39974 16.7018 9.3151 16.7344 9.21094 16.7344H4.58203C4.47786 16.7344 4.38672 16.7018 4.30859 16.6367C4.24349 16.5586 4.21094 16.4674 4.21094 16.3633V12.3984C4.21094 12.2943 4.24349 12.2096 4.30859 12.1445C4.38672 12.0664 4.47786 12.0273 4.58203 12.0273H6.53516V9.56641H4.58203C4.47786 9.56641 4.38672 9.53385 4.30859 9.46875C4.24349 9.39062 4.21094 9.30599 4.21094 9.21484V7.51562H1.33984V19.4102H19.6602V7.51562H16.9844ZM1.33984 6.77344V1.08984H19.6602V6.77344H16.8281L14.3672 4.33203C14.2891 4.26693 14.1979 4.23438 14.0938 4.23438C14.0026 4.23438 13.918 4.26693 13.8398 4.33203L11.3789 6.77344H9.58203V5.25C9.58203 5.14583 9.54297 5.0612 9.46484 4.99609C9.39974 4.91797 9.3151 4.87891 9.21094 4.87891H4.58203C4.47786 4.87891 4.38672 4.91797 4.30859 4.99609C4.24349 5.0612 4.21094 5.14583 4.21094 5.25V6.77344H1.33984Z",
      fill: "currentColor"
    }
  )
);
const SvgLapModeling = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var LapModeling_default = SvgLapModeling;
